import { useMemo } from 'react'
import { getRandomValueFromArray } from '../utils/arrayUtils'

export const useRandomValueFromArray = array => {
  return useMemo(() => getRandomValueFromArray(array), [array])
}
